import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import Header from "./components/essentials/Header"
import Footer from "./components/essentials/Footer"

import NotFound from "./pages/NotFound";
import QrOverview from "./pages/QROverview";
import Helper from "./pages/Helper";
import Student from "./pages/Student";
import Teacher from "./pages/Teacher";

function App() {
    const [reloadKey, setReloadKey] = useState(0);
    useEffect(() => {
        window.addEventListener("ws-reconnect", () => {
            setReloadKey(prev => prev+1);
        });
        return () => {
            window.removeEventListener("ws-reconnect");
        };
    }, []);

    return (
        <div className="App" key={reloadKey}>
            <Header />
            <BrowserRouter>
                <Routes>
                    <Route path='/elev/:kategoriEncoded/:tallidEncoded' element={<Student />} />
                    <Route path='/leksehjelper' element={<Helper />} />
                    <Route path='/qr-kode-oversikt' element={<QrOverview />} />
                    <Route path='/laerer' element={<Teacher />} />
                    <Route path='*' element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Footer />
        </div>
    );
}

export default App;
